import * as React from 'react';
import { ReleaseComponentProps } from '../../typescriptHelpers';
import Alert from 'antd/lib/alert';
import Button from 'antd/lib/button';
import { BulbFilled } from '@ant-design/icons';
import userflow from 'userflow.js';
import { colorWithAlpha, rwColors } from '../styles/globalStyles';
import {
    setUserViewedReleaseSurveyForRelease,
    getUserViewedReleaseSurveyForRelease,
} from '../../helpers/localStorageHelper';
import { useSelector } from 'react-redux';
import { selectIsDemoInstanceOrDemoModeEnabled, selectUserIsRunwayAdmin } from '@/selectors/selectors';
import { RootState } from '@/reducers/reducers';

const USERLFOW_RELEASE_FEEDBACK_FLOW_ID = '9bcc579e-33ba-4018-821a-727301341e41';

const ReleaseFeedbackPrompt: React.FC<ReleaseComponentProps> = (props: ReleaseComponentProps) => {
    const hasUserSeenFeedbackSurvey = getUserViewedReleaseSurveyForRelease(props.releaseId);

    const isDemoInstance = useSelector((state: RootState) =>
        selectIsDemoInstanceOrDemoModeEnabled(state, props.orgId, props.releaseId),
    );
    const isRunwayAdmin = useSelector((state: RootState) => selectUserIsRunwayAdmin(state));

    const showUserflowReleaseFeedback = () => {
        userflow.start(USERLFOW_RELEASE_FEEDBACK_FLOW_ID);
    };

    React.useEffect(() => {
        const showFeedbackSurvey = !hasUserSeenFeedbackSurvey && !isRunwayAdmin && !isDemoInstance;

        if (showFeedbackSurvey) {
            // release pilot has not previously been shown then survey, show
            showUserflowReleaseFeedback();

            // record the view so it's not shown automatically again
            setUserViewedReleaseSurveyForRelease(props.releaseId, true);
        }
    }, [props.releaseId]);

    return (
        <Alert
            type="info"
            icon={<BulbFilled />}
            message="Give us your feedback! How did this release go?"
            style={{
                marginBottom: 20,
                borderStyle: 'solid',
                borderColor: colorWithAlpha(rwColors.primary, 0.8),
                borderWidth: 1,
            }}
            showIcon
            action={
                <Button size="small" onClick={showUserflowReleaseFeedback} type="primary">
                    Tell us how this release went
                </Button>
            }
        />
    );
};

export default ReleaseFeedbackPrompt;
